import { defineMessages } from 'react-intl';
const messages = defineMessages({
    EmptyReceiveInvoiceSoftware: {
        id: 'EmptyReceiveInvoiceSoftware',
        defaultMessage: 'Without receive invoice software',
    },
    SendInvoiceSoftware: {
        id: 'SendInvoiceSoftware',
        defaultMessage: 'SendInvoiceSoftware',
    },
    ReceiveInvoiceSoftware: {
        id: 'ReceiveInvoiceSoftware',
        defaultMessage: 'ReceiveInvoiceSoftware',
    },
    ReferenceYear: {
        id: 'ReferenceYear',
        defaultMessage: 'Reference year',
    },
    TaskBoard: {
        id: 'TaskBoard',
        defaultMessage: 'Task board',
    },
    CollapseAll: {
        id: 'CollapseAll',
        defaultMessage: 'Collapse all',
    },
    ExpandAll: {
        id: 'ExpandAll',
        defaultMessage: 'Expand all',
    },
    EmptyAccountingSoftware: {
        id: 'EmptyAccountingSoftware',
        defaultMessage: 'Empty accounting software',
    },
    TasksAssignedTo: {
        id: 'TasksAssignedTo',
        defaultMessage: 'Tasks assigned to',
    },
    NotAssignedToMe: {
        id: 'NotAssignedToMe',
        defaultMessage: 'Not assigned to me',
    },
    SelectTask: {
        id: 'SelectTask',
        defaultMessage: 'Select task',
    },
    Status: {
        id: 'Status',
        defaultMessage: 'Status',
    },
    SubtaskStatus: {
        id: 'SubtaskStatus',
        defaultMessage: 'Subtask status',
    },
    DeadlineFrom: {
        id: 'DeadlineFrom',
        defaultMessage: 'Deadline from',
    },
    DeadlineUntil: {
        id: 'DeadlineUntil',
        defaultMessage: 'Deadline until',
    },
    DeadlineFromPlaceholder: {
        id: 'DeadlineFromPlaceholder',
        defaultMessage: 'Deadline from',
    },
    DeadlineUntilPlaceholder: {
        id: 'DeadlineUntilPlaceholder',
        defaultMessage: 'Deadline until',
    },
    ExecutionDateFrom: {
        id: 'ExecutionDateFrom',
        defaultMessage: 'Execution from',
    },
    ExecutionDateUntil: {
        id: 'ExecutionDateUntil',
        defaultMessage: 'Execution until',
    },
    SortByExecutionDate: {
        id: 'SortByExecutionDate',
        defaultMessage: 'Sort by execution date',
    },
    SelectASubtask: {
        id: 'SelectASubtask',
        defaultMessage: 'Select a subtask',
    },
    FilterPeriodicity: {
        id: 'FilterPeriodicity',
        defaultMessage: 'Filter task periodicity',
    },
    VatPeriodicity: {
        id: 'VatPeriodicity',
        defaultMessage: 'VAT periodicity',
    },
    AccountingSoftware: {
        id: 'AccountingSoftware',
        defaultMessage: 'Accounting software',
    },
    OtherSoftware: {
        id: 'OtherSoftware',
        defaultMessage: 'Other software',
    },
    OwnCompanies: {
        id: 'OwnCompanies',
        defaultMessage: 'Own companies',
    },
    LegalEntity: {
        id: 'LegalEntity',
        defaultMessage: 'Legal entity',
    },
    EndFiscalYear: {
        id: 'EndFiscalYear',
        defaultMessage: 'End fiscal year',
    },
    CreatedBy: {
        id: 'CreatedBy',
        defaultMessage: 'Created by',
    },
    LegalForms: {
        id: 'LegalForms',
        defaultMessage: 'Legal forms',
    },
    RelationsAssignedTo: {
        id: 'RelationsAssignedTo',
        defaultMessage: 'Relation assigned to',
    },
    WithRelationLabels: {
        id: 'WithRelationLabels',
        defaultMessage: 'Relation labels (with)',
    },
    WithoutRelationLabels: {
        id: 'WithoutRelationLabels',
        defaultMessage: 'Relation labels (without)',
    },
    RelationType: {
        id: 'RelationType',
        defaultMessage: 'Relation type',
    },
    CrmType: {
        id: 'CrmType',
        defaultMessage: 'CRM type',
    },
    Teams: {
        id: 'Teams',
        defaultMessage: 'Teams',
    },
    RelationTeams: {
        id: 'RelationTeams',
        defaultMessage: 'Relation teams',
    },
    WithLabels: {
        id: 'WithLabels',
        defaultMessage: 'With labels',
    },
    WithoutLabels: {
        id: 'WithoutLabels',
        defaultMessage: 'Without labels',
    },
    WithTaskLabels: {
        id: 'WithTaskLabels',
        defaultMessage: 'With task labels',
    },
    WithoutTaskLabels: {
        id: 'WithoutTaskLabels',
        defaultMessage: 'Without task labels',
    },
    ShowOnlySubtaskAssignedToSelectedUser: {
        id: 'ShowOnlySubtaskAssignedToSelectedUser',
        defaultMessage: 'Show only subtask assigned to selected user',
    },
    AssignmentTemplate: {
        id: 'AssignmentTemplate',
        defaultMessage: 'Assignment template',
    },
    Add: {
        id: 'Add',
        defaultMessage: 'Add',
    },
    FinancialStatementScheme: {
        id: 'FinancialStatementScheme',
        defaultMessage: 'FinancialStatementScheme',
    },
    SocialSecurityFund: {
        id: 'SocialSecurityFund',
        defaultMessage: 'SocialSecurityFund',
    },
    SocialSecretariat: {
        id: 'SocialSecretariat',
        defaultMessage: 'SocialSecretariat',
    },
    ShowTasksWhereSelectedUserIsNextInLine: {
        id: 'ShowTasksWhereSelectedUserIsNextInLine',
        defaultMessage: 'Show tasks where the selected user is next in line',
    },
    ShowTasksWhereSelectedUserIsNextInLineTooltip: {
        id: 'ShowTasksWhereSelectedUserIsNextInLineTooltip',
        defaultMessage: 'When you have selected a user, this filter will only show the tasks where that user is next in line and can start working on the tasks.',
    },
    IncludeDoneTasksInThePast: {
        id: 'IncludeDoneTasksInThePast',
        defaultMessage: 'IncludeDoneTasksInThePast',
    },
    RelationGroups: {
        id: 'RelationGroups',
        defaultMessage: 'Relation groups',
    },
    MixedTaxPayer: {
        id: 'MixedTaxPayer',
        defaultMessage: 'Mixed tax payer',
    },
    MixedTaxPayerVatDeductionMethod: {
        id: 'MixedTaxPayerVatDeductionMethod',
        defaultMessage: 'Mixed tax payer vat deduction method',
    },
    EmptyMixedTaxPayerVatDeductionMethod: {
        id: 'EmptyMixedTaxPayerVatDeductionMethod',
        defaultMessage: 'Without mixed tax payer VAT deduction method',
    },
    Selfbooker: {
        id: 'Selfbooker',
        defaultMessage: 'Selfbooker',
    },
    RelationHandlingLevel: {
        id: 'RelationHandlingLevel',
        defaultMessage: 'Treatment level',
    },
    CapitalGainsTax: {
        id: 'CapitalGainsTax',
        defaultMessage: 'Capital gains tax',
    },
    Statute: {
        id: 'Statute',
        defaultMessage: 'Statute',
    },
});
export default messages;
